
import { Component, Vue } from 'vue-property-decorator';
import Promote from '@/views/marketing/promote-code/components/promote.vue';
import PromoteDetail from '@/views/marketing/promote-code/components/promote-detail.vue';
@Component({
  components: { Promote, PromoteDetail },
})
export default class extends Vue {
  currentComponent: string = 'promote';
  item: any = {};
  promoteDateil(data: any) {
    this.item = data;
    this.currentComponent = 'PromoteDetail';
  }
  goback() {
    this.currentComponent = 'promote';
  }
}
